import styled from "styled-components";
import { Icon } from "@/shared/components/Icon";
import type { CreatorInvitationUnavailableState } from "../../hooks/useCreatorInvitation";
import {
	getCreatorInvitationUnavailableAction,
	getCreatorInvitationUnavailableCopy,
} from "../../utils/creatorInvitationUnavailable";

const Page = styled.main`
	min-height: 100vh;
	box-sizing: border-box;
	display: grid;
	place-items: center;
	padding: 32px 20px;
	background: url("/Login_Desktop_Background.png") center / cover no-repeat;
`;

const Shell = styled.div`
	width: min(100%, 520px);
`;

const Wordmark = styled.img`
	display: block;
	width: min(300px, 70vw);
	margin: 0 auto 28px;
`;

const Card = styled.section`
	box-sizing: border-box;
	padding: 32px;
	border-radius: 24px;
	background: #f3f5ff;
	box-shadow: 0 12px 24px rgb(21 89 165 / 24%);
	text-align: center;

	@media (max-width: 520px) {
		padding: 28px 20px;
	}
`;

const Badge = styled.div`
	display: grid;
	place-items: center;
	width: 44px;
	height: 44px;
	margin: 0 auto 24px;
	border-radius: 8px;
	background: rgb(216 0 39 / 11%);
	color: #d80027;
`;

const Title = styled.h1`
	margin: 0;
	color: #303030;
	font-size: 24px;
	font-weight: 600;
	line-height: 1.3;
	white-space: nowrap;

	@media (max-width: 560px) {
		white-space: normal;
	}
`;

const Body = styled.p`
	margin: 16px 0 28px;
	color: #454545;
	font-size: 16px;
	line-height: 1.55;
`;

const Action = styled.a`
	display: flex;
	width: min(100%, 364px);
	min-height: 52px;
	align-items: center;
	justify-content: center;
	box-sizing: border-box;
	margin: 0 auto;
	padding: 16px 24px;
	border-radius: 999px;
	background: #3a0ca3;
	color: #fff;
	font-size: 16px;
	font-weight: 600;
	text-decoration: none;

	&:hover {
		background: #3a0ca3;
		color: #fff;
		filter: brightness(1.08);
	}

	&:focus-visible {
		outline: 3px solid rgb(58 12 163 / 30%);
		outline-offset: 3px;
	}
`;

export const CreatorInvitationUnavailable = ({ state }: { state: CreatorInvitationUnavailableState }) => {
	const copy = getCreatorInvitationUnavailableCopy(state);
	const action = getCreatorInvitationUnavailableAction(state);

	return (
		<Page>
			<Shell>
				<Wordmark src="/Creatorverse_Wordmark_Gradient.svg" alt="Creatorverse" />
				<Card aria-labelledby="invitation-unavailable-title">
					<Badge>
						<Icon name="xCircle" size={24} aria-hidden="true" preserveOriginalColor />
					</Badge>
					<Title id="invitation-unavailable-title">{copy.title}</Title>
					<Body>{copy.body}</Body>
					<Action
						href={action.href}
						target={action.href === "/" ? undefined : "_blank"}
						rel={action.href === "/" ? undefined : "noopener noreferrer"}
					>
						{action.label}
					</Action>
				</Card>
			</Shell>
		</Page>
	);
};
